import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { EDayType } from 'projects/shared/lib/enum/time/day-type.enum';

/**
 * Pipe regarding the translation day type enum entries to a string.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see EDayTypeToStringService
 */
@Pipe({
  name: 'eDayTypeToStringPipe',
  standalone: true
})
export class EDayTypeToStringPipe implements PipeTransform {

  public transform(dayType: EDayType | undefined): string {
    return EDayTypeToStringService.transform(dayType);
  }

}

/**
 * Pipe regarding the translation day type enum entries to a string.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see EDayTypeToStringPipe
 */
@Injectable({
  providedIn: 'root'
})
export class EDayTypeToStringService {

  public static transform(dayType: EDayType | undefined): string {
    let dayTypeString: string = '';
    switch (dayType) {
      case undefined: {
        break;
      }
      case EDayType.Default: {
        dayTypeString = `default`;
        break;
      }
      case EDayType.Holiday: {
        dayTypeString = `holiday`;
        break;
      }
      default: {
        throw new Error(`Missing implementation for day type passed to pipe: ${dayType}.`);
      }

    }

    return dayTypeString;
  }

}
